module.exports = __webpack_public_path__ + "static/media/logo.dced6e5c.svg";